import { AiFeature } from '../../../../../../models/AiFeature'
import { AiResult } from '../../../../../../models/AiResult'
import React, { useMemo } from 'react'
import { formatDate } from '../../../common/aifeatures/utils'
import { SelectDropdown, SelectOption } from '../../../../../../components/SelectDropdown/SelectDropdown'

interface ResultSelectorProps {
  aiFeature: AiFeature
  aiResults: AiResult[]
  onResultSelected: (selectedResult: AiResult) => void
}

export const ResultSelector: React.FC<ResultSelectorProps> = ({ aiFeature, aiResults, onResultSelected }) => {
  const getLabel = (aiResult: AiResult) => {
    const { name } = aiFeature
    const { createdAt } = aiResult
    return `${name} - ${formatDate(createdAt)}`
  }

  const options = useMemo(() => aiResults.map((aiResult) => ({ id: aiResult.id, label: getLabel(aiResult) })), [aiResults])

  const handleOptionSelected = (option: SelectOption) => {
    const { id: aiResultId } = option
    const selectedResult = aiResults.find((aiResult) => aiResult.id === aiResultId)
    if (!selectedResult) {
      return
    }
    onResultSelected(selectedResult)
  }

  return (
    <div className='mb-5 position-relative'>
      <div className='position-absolute w-100'>
        <SelectDropdown className='py-2 zocks-px-0.75' options={options} onOptionSelected={handleOptionSelected} />
      </div>
    </div>
  )
}
